import { Box, Text } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";

export function BoxVigencia({ props, detalhes = false }) {
  const { validadede, validoapartir } = props;
  const {personalizacao: {card}} = usePersonalizacao();

  return (
    <>
      {validoapartir && (
        <Box
          background={!validoapartir ? "transparent" : card.colorpreco}
          borderRadius={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
          paddingX="0.5625rem"
          paddingY={detalhes ? "0.5rem" : "0.25rem"}
          marginTop="0.75rem"
        >
          <Text
            fontSize={detalhes ? "0.75rem" : "0.625rem"}
            fontWeight="bold"
            textAlign="center"
            color={card.colortextopercentual}
          >
            {`Válido a partir de ${new Intl.DateTimeFormat("pt-BR", {
              timeZone: "UTC",
            }).format(new Date(validadede))}`}
          </Text>
        </Box>
      )}
    </>
  );
}
